import { AppSettingsHomePageDTO } from "@gymflow/types";

const removePosition = <T extends { position: number }>(data: T) => {
  const { position, ...rest } = data;
  return rest;
};

export const mapBEtoFE = (data: AppSettingsHomePageDTO) => {
  return {
    checkInWidgetEnabled: {
      id: "checkIn" as const,
      enabled: data.checkInWidgetEnabled,
    },
    ctas: [
      {
        id: "buyMembership" as const,
        enabled: data.buyMembershipWidgetEnabled,
        position: data.buyMembershipWidgetPosition,
      },
      {
        id: "buyCreditPack" as const,
        enabled: data.buyPackageWidgetEnabled,
        position: data.buyPackageWidgetPosition,
      },
    ]
      .sort((a, b) => a.position - b.position)
      .map((e) => removePosition(e)),
    widgets: [
      {
        id: "gymCapacity" as const,
        enabled: data.gymCapacityWidgetEnabled,
        position: data.gymCapacityWidgetPosition,
        dontShowOnUI: true,
      },
      {
        id: "appointmentBooking" as const,
        enabled: data.appointmentBookingWidgetEnabled,
        position: data.appointmentBookingWidgetPosition,
      },
      {
        id: "classBooking" as const,
        enabled: data.classBookingWidgetEnabled,
        position: data.classBookingWidgetPosition,
      },
      {
        id: "classAttendance" as const,
        enabled: data.classAttendanceWidgetEnabled,
        position: data.classAttendanceWidgetPosition,
      },
      {
        id: "appointmentAttendance" as const,
        enabled: data.appointmentAttendanceWidgetEnabled,
        position: data.appointmentAttendanceWidgetPosition,
      },
      {
        id: "gymAttendance" as const,
        enabled: data.gymAttendanceWidgetEnabled,
        position: data.gymAttendanceWidgetPosition,
      },
      {
        id: "newsFeed" as const,
        enabled: data.newsFeedWidgetEnabled,
        position: data.newsFeedWidgetPosition,
        dontShowOnUI: true,
      },
    ]
      .sort((a, b) => a.position - b.position)
      .map((e) => removePosition(e)),
  };
};
export type FEAppSettingsHomePage = ReturnType<typeof mapBEtoFE>;
export const mapFEtoBE = (
  data: FEAppSettingsHomePage,
): AppSettingsHomePageDTO => {
  const buyMembershipIndex = data.ctas.findIndex(
    (cta) => cta.id === "buyMembership",
  );
  const buySessionPackIndex = data.ctas.findIndex(
    (cta) => cta.id === "buyCreditPack",
  );
  const gymCapacityIndex = data.widgets.findIndex(
    (widget) => widget.id === "gymCapacity",
  );
  const appointmentBookingIndex = data.widgets.findIndex(
    (widget) => widget.id === "appointmentBooking",
  );
  const classBookingIndex = data.widgets.findIndex(
    (widget) => widget.id === "classBooking",
  );
  const classAttendanceIndex = data.widgets.findIndex(
    (widget) => widget.id === "classAttendance",
  );
  const appointmentAttendanceIndex = data.widgets.findIndex(
    (widget) => widget.id === "appointmentAttendance",
  );
  const gymAttendanceIndex = data.widgets.findIndex(
    (widget) => widget.id === "gymAttendance",
  );
  const newsFeedIndex = data.widgets.findIndex(
    (widget) => widget.id === "newsFeed",
  );

  return {
    checkInWidgetEnabled: data.checkInWidgetEnabled.enabled,
    buyMembershipWidgetEnabled: data.ctas[buyMembershipIndex].enabled,
    buyMembershipWidgetPosition: buyMembershipIndex,
    buyPackageWidgetEnabled: data.ctas[buySessionPackIndex].enabled,
    buyPackageWidgetPosition: buySessionPackIndex,
    gymCapacityWidgetEnabled: data.widgets[gymCapacityIndex].enabled,
    gymCapacityWidgetPosition: gymCapacityIndex,
    appointmentBookingWidgetEnabled:
      data.widgets[appointmentBookingIndex].enabled,
    appointmentBookingWidgetPosition: appointmentBookingIndex,
    classBookingWidgetEnabled: data.widgets[classBookingIndex].enabled,
    classBookingWidgetPosition: classBookingIndex,
    classAttendanceWidgetEnabled: data.widgets[classAttendanceIndex].enabled,
    classAttendanceWidgetPosition: classAttendanceIndex,
    gymAttendanceWidgetEnabled: data.widgets[gymAttendanceIndex].enabled,
    gymAttendanceWidgetPosition: gymAttendanceIndex,
    appointmentAttendanceWidgetEnabled:
      data.widgets[appointmentAttendanceIndex].enabled,
    appointmentAttendanceWidgetPosition: appointmentAttendanceIndex,
    newsFeedWidgetEnabled: data.widgets[newsFeedIndex].enabled,
    newsFeedWidgetPosition: newsFeedIndex,
  };
};

export const appSettingsHelper = {
  mapBEtoFE,
  mapFEtoBE,
};
